<h2 mat-dialog-title>Choose Unit to Show Calculated Charges For</h2>
<mat-dialog-content data-form-ready="true">
    <app-ctl-holder [control]="unitField.control"></app-ctl-holder>
    <button mat-raised-button data-save-button [disabled]="unitField.control.invalid"
    color="primary" (click)="addUnit()">Show Charges</button>
</mat-dialog-content>
